export const validations = {
  Name: {
    regex: /^[a-zA-ZÀ-ÿ\s'-]+$/,
    emptyErrorMessage: "Il nome è obbligatorio",
    invalidErrorMessage: "Questo campo può contenere solo lettere.",
  },
  Cognome: {
    regex: /^[a-zA-ZÀ-ÿ\s'-]+$/,
    emptyErrorMessage: "Il cognome è obbligatorio",
    invalidErrorMessage: "Questo campo può contenere solo lettere.",
  },
  // provincia: {
  //   regex: // Define regex for provincia if needed,
  //   emptyErrorMessage: "",
  //   invalidErrorMessage: "",
  // },
  // comune: {
  //   regex: // Define regex for comune if needed,
  //   emptyErrorMessage: "",
  //   invalidErrorMessage: "",
  // },
  CF: {
    regex:
      /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$/,
    emptyErrorMessage: "Il Codice Fiscale è obbligatorio",
    invalidErrorMessage: "Codice fiscale non valido.",
  },
  CAP: {
    regex: /^\d{5}$/,
    emptyErrorMessage: "Il CAP è obbligatorio",
    invalidErrorMessage: "Questo campo può contenere solo numeri.",
  },
  IndirizzoVia: {
    regex: /^[a-zA-Z0-9\s.,'-]{1,70}$/,
    emptyErrorMessage: "L'indirizzo è obbligatorio",
    invalidErrorMessage:
      "Questo campo può contenere solo lettere, numeri e caratteri speciali.",
  },
  IndirizzoResidenza: {
    regex: /^[a-zA-Z0-9\s.,'-]{1,70}$/,
    emptyErrorMessage: "L'indirizzo è obbligatorio",
    invalidErrorMessage:
      "Questo campo può contenere solo lettere, numeri e caratteri speciali.",
  },
  Civico: {
    regex: /^[a-zA-Z0-9\s'-\/]+$/,
    emptyErrorMessage: "Il numero civico è obbligatorio",
    invalidErrorMessage:
      "Questo campo può contenere solo lettere, numeri e caratteri speciali.",
  },
  Telefono: {
    regex: /^\+?[0-9\s-]{1,20}$/,
    emptyErrorMessage: "Il numero di telefono è obbligatorio",
    invalidErrorMessage: "Inserisci un numero di telefono valido.",
  },
  Cellulare: {
    regex: /^\+?[0-9\s-]{1,20}$/,
    emptyErrorMessage: "Il numero di cellulare è obbligatorio",
    invalidErrorMessage: "Inserisci un numero di cellulare valido.",
  },
  Email: {
    regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    emptyErrorMessage: "L'email è obbligatoria",
    invalidErrorMessage: "Inserisci un'email valida.",
  },
  PEC: {
    regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    emptyErrorMessage: "Il PEC è obbligatoria",
    invalidErrorMessage: "Inserisci un'email valida.",
  },
  Sito: {
    regex:
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()+,;=])?$/,
    emptyErrorMessage: "Il sito web è obbligatorio",
    invalidErrorMessage: "Inserisci un sito web valido.",
  },
  preventiviEmail: {
    regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    emptyErrorMessage: "L'email per i preventivi è obbligatoria",
    invalidErrorMessage: "Inserisci un'email valida per i preventivi.",
  },
  preventiviCellulare: {
    regex: /^\+?[0-9\s-]{1,20}$/,
    emptyErrorMessage: "Il numero di cellulare per i preventivi è obbligatorio",
    invalidErrorMessage:
      "Inserisci un numero di cellulare valido per i preventivi.",
  },
  Fax: {
    regex: /^\+?[0-9\s-]{1,20}$/,
    emptyErrorMessage: "Il numero fax è obbligatorio",
    invalidErrorMessage: "Inserisci un numero di fax valido.",
  },
  Facebook: {
    regex:
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()+,;=])?$/,
    emptyErrorMessage: "Il sito web è obbligatorio",
    invalidErrorMessage: "Inserisci un sito web valido.",
  },
  Linkedin: {
    regex:
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()+,;=])?$/,
    emptyErrorMessage: "Il profilo Linkedin è obbligatorio",
    invalidErrorMessage: "Inserisci un profilo Linkedin valido.",
  },
  Instagram: {
    regex:
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()+,;=])?$/,
    emptyErrorMessage: "Il profilo Instagram è obbligatorio",
    invalidErrorMessage: "Inserisci un profilo Instagram valido.",
  },
  Twitter: {
    regex:
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()+,;=])?$/,
    emptyErrorMessage: "Il profilo Twitter è obbligatorio",
    invalidErrorMessage: "Inserisci un profilo Twitter valido.",
  },
  CodiceRUI: {
    regex: /^\d{9}$/,
    emptyErrorMessage: "Il numero RUI IVASS è obbligatorio",
    invalidErrorMessage: "Inserisci un numero RUI IVASS valido.",
  },
  Data_Iscrizione: {
    regex: /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/,
    emptyErrorMessage: "La data di iscrizione IVASS è obbligatoria",
    invalidErrorMessage: "Inserisci una data di iscrizione IVASS valida.",
  },
  Data_Nascita: {
    regex: /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/,
    emptyErrorMessage: "La data di nascita è obbligatoria",
    invalidErrorMessage: "Inserisci una data di nascita valida.",
  },
  // CF_PIVA: {
  //   regex: // Define regex,
  //   emptyErrorMessage: "Questo campo è obbligatorio",
  //   invalidErrorMessage: "Inserisci un codice fiscale o partita iva valida.",
  // },
  // Indirizzo: {
  //   regex: // Define regex,
  //   emptyErrorMessage: "L'indirizzo è obbligatorio",
  //   invalidErrorMessage: "Inserisci un indirizzo valido.",
  // },
  // RUI_Codice: {
  //   regex: // Define regex,
  //   emptyErrorMessage: "Il codice RUI è obbligatorio",
  //   invalidErrorMessage: "Inserisci un codice RUI valido.",
  // },
  // ComuneCodice: {
  //   regex: // Define regex,
  //   emptyErrorMessage: "Il codice comune è obbligatorio",
  //   invalidErrorMessage: "Inserisci un codice comune valido.",
  // },
  // Provincia_Estesa: {
  //   regex: // Define regex,
  //   emptyErrorMessage: "La provincia estesa è obbligatoria",
  //   invalidErrorMessage: "Inserisci una provincia estesa valida.",
  // },

  RUI_DataIscrizione: {
    regex: /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/,
    emptyErrorMessage: "La data di iscrizione del titolare è obbligatoria",
    invalidErrorMessage: "Inserisci una data di iscrizione valida.",
  },
};
